import React from "react";
import ServerPaginatedTable from "../utils/pagination.server";
import moment from "moment";
import PdfIcon from "react-icons/lib/md/picture-as-pdf";
import ExcelIcon from "react-icons/lib/md/insert-drive-file";
import ToolTipItem from "../utils/tooltip";
import PageEmptyContent from "../utils/page.empty-content";
import ReportIcon from "react-icons/lib/ti/clipboard";
import { store } from "../../_helpers";

const DataTable = ({ data, downloadPdf, downloadExcel, totalCount, }) => {
  const { authentication } = store.getState();

  if (!data || !Array.isArray(data) || data.length === 0) {
    return <PageEmptyContent message="No record match your search!" />;
  }

  return (
    <div className="view">
      <div className="row">
        <div className="col-sm-6">
          <h5 className="font-weight-normal mb-2">
            <ReportIcon size="22" color="#43a8df" />
            {totalCount} records matched
          </h5>
        </div>
        {/*Files to be downloaded*/}
        <div className="col-sm-6">
          <div className="text-right" style={{ marginBottom: "20px" }}>
            <strong>Download: </strong>
            <span className="pointer" onClick={downloadPdf}>
              <ToolTipItem
                key={"downloadPdfIcon"}
                title={
                  <PdfIcon
                    size="18"
                    color="#e53335"
                    className="icon-picture-as-pdf"
                  />
                }
                content="Download PDF"
                id={"downloadPdfIcon"}
              />
            </span>
            &nbsp;
            <span className="pointer" onClick={downloadExcel}>
              <ToolTipItem
                key={"downloadExcelIcon"}
                title={
                  <ExcelIcon
                    size="18"
                    color="#5ead57"
                    className="icon-insert-drive-file"
                  />
                }
                content="Download Excel"
                id={"downloadExcelIcon"}
              />
            </span>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>
                <span>Airline</span>
              </th>
              <th>
                <span>Flight number</span>
              </th>
              <th>
                <span>Route</span>
              </th>
              <th>
                <span>Flight date</span>
              </th>
              <th>
                <span>Pax Count</span>
              </th>
              <th>
                <span>Location</span>
              </th>
              <th>
                <span>Submitted date</span>
              </th>
              <th>
                <span>Aggregate status</span>
              </th>
              <th>
                <span>Bill date</span>
              </th>
              <th>
                <span>Extra PAX</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((record, i) => (
              <tr key={i + 1}>
                <td className="text-capitalize">{record.Airline}</td>
                <td>{record.FlightNumber}</td>
                <td>{`${record.Origin} - ${record.Destination}`}</td>
                <td>{moment(record.FlightDate).format("MMM Do YYYY")}</td>
                <td>
                  {record.PassengersCount === null
                    ? ""
                    : record.PassengersCount}
                </td>
                <td>{record.Origin}</td>
                <td>{moment(record.DateSubmitted).format("MMM Do YYYY")}</td>
                <td
                  style={{
                    color:
                      record.AggregateStatus === "Completed"
                        ? "#5DAD57"
                        : record.AggregateStatus === "Pending"
                        ? "#E59100"
                        : "inherit", // Default text color
                  }}
                >
                  {record.AggregateStatus}
                </td>
                <td>
                  {record.InvoiceDate
                    ? moment(record.InvoiceDate).format("MMM Do YYYY")
                    : ""}
                </td>
                <td>{record.ExtraPassengerCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

class PaginatedResult extends React.Component {
  render() {
    const {
      downloadPdf,
      downloadExcel,
      pageSize,
      currentPage,
      totalCount,
      navigate,
      records,
    } = this.props;
    // let pageIndex = currentPage * pageSize;
    let pageIndex = (currentPage - 1) * pageSize;
console.log(pageIndex, "pageIndex");
    return (
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12 mb-4">
            <ServerPaginatedTable
              currentPage={currentPage}
              fetchMore={navigate}
              target={
                <DataTable
                  downloadPdf={downloadPdf}
                  downloadExcel={downloadExcel}
                  data={records}
                  totalCount={totalCount}
                  pageIndex={pageIndex}
                />
              }
              pageSize={pageSize}
              totalCount={totalCount}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PaginatedResult;



// WEBPACK FOOTER //
// ./src/views/flight-operations/record.js